import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { useState } from "react";
import { imageDb } from "../../firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import imageCompression from "browser-image-compression";

export default function Compteam() {


  const upload_preset = process.env.REACT_APP_UPLOAD_PRESET_RANKTEAM;
  const cloud_name = process.env.REACT_APP_CLOUD_NAME_RANKTEAM;

  const urlapi = process.env.REACT_APP_BASE_URL;
  const [namateam, setNamateam] = useState("");
  const [nameImg, setNameImg] = useState("");
  const [valueimg, setvalueimg] = useState("");
  const [img, setImg] = useState("");
  const [teamrank, setTeamrank] = useState([]);
  const [load, setLoad] = useState(false);
  const [ubahteam, setUbahteam] = useState(false);
  const [cekbookingteam, setCekbookingteam] = useState([]);
  const [image, setImage] = useState(null);
  const [loadingupload2, setLoadingUpload2] = useState(false);

  const navigate = useNavigate();

  const notify = () =>
    toast.success("Data team berhasil di tambah !", {
      position: toast.POSITION.TOP_CENTER,
    });
  const notifyupdate = () =>
    toast.success("Data team berhasil di ubah !", {
      position: toast.POSITION.TOP_CENTER,
    });

  const handleChangeImg = async (e) => {
    setLoad(true);
    const file = e.target.files[0];
    setImg(e.target.files[0]);
    // console.log(e);
    setvalueimg(e.target.value);
    setNameImg(e.target.files[0].name);

    const options = {
      maxSizeMB: 1, // Maksimum ukuran gambar dalam MB
      maxWidthOrHeight: 800, // Dimensi maksimum
      useWebWorker: true,
    };

    try {
      const compressedFile = await imageCompression(file, options);
      // Pratinjau gambar
      // setPreview(URL.createObjectURL(compressedFile));
      setImage(compressedFile); // Simpan gambar yang sudah dikompres
      setLoadingUpload2(true)

      console.log(compressedFile);

    } catch (error) {
      console.error("Gagal mengompres gambar:", error);
    }

  };


  const handleDatateam = async () => {
    setLoad(true);
    // setLoading(true);
    // setLoadingpage(true);

    if (!image) return
    const data = new FormData();
    data.append('file', image);
    data.append('upload_preset', upload_preset);
    data.append('cloud_name', cloud_name);

    const res = await fetch(`https://api.cloudinary.com/v1_1/${cloud_name}/image/upload`, {
      method: "POST",
      body: data
    })

    const uploadedImageUrl = await res.json()
    console.log(uploadedImageUrl.url);

    if (ubahteam == false) {
      addDatateam(uploadedImageUrl.url);
    } else {
      ubahDatateam(uploadedImageUrl.url);
    }
    // addDatateam(uploadedImageUrl.url)


    // const imgRef = ref(imageDb, `files/${nameImg}`);
    // uploadBytes(imgRef, img);
    // console.log(imgRef._location.path_);

    // setTimeout(() => {
    //   getDownloadURL(ref(imageDb, `files/${nameImg}`)).then((url) => {
    //     console.log("prosess");
    //     // setForm(false);
    //     if (ubahteam == false) {
    //       addDatateam(url);
    //     } else {
    //       ubahDatateam(url);
    //     }
    //   });
    // }, 10000);
  };

  const addDatateam = async (url) => {
    await axios
      .post(urlapi + "Datateam", {
        id_user: localStorage.getItem("id"),
        namateam: namateam,
        logoteam: url,
      })

      .then((response) => {
        getteam();
        notify();
        navigate("/daftarteamrankteam/add");
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  const ubahDatateam = async (url) => {
    await axios
      .post(urlapi + "Datateam", {
        id_user: localStorage.getItem("id"),
        namateam: namateam,
        logoteam: url,
        ubah: "1",
      })

      .then((response) => {
        getteam();
        notifyupdate();
        navigate("/daftarteamrankteam/add");
        setUbahteam(false);
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  const getteam = async () => {
    try {
      const response = await axios.get(
        urlapi + "Datateam?id_user=" + localStorage.getItem("id")
      );
      setTeamrank(response.data);
    } catch (error) { }
  };

  const cekteam = async () => {
    try {
      const response = await axios.get(
        urlapi + "Cekbookingteam?id_user=" + localStorage.getItem("id")
      );
      setCekbookingteam(response.data.id_user);
      // console.log(response.data.id_user);
    } catch (error) { }
  };

  const KlikUbahTeam = () => {

    setUbahteam(true);
    setLoad(false);
    setLoadingUpload2(false);
    setNameImg('');

  }



  useEffect(() => {
    getteam();
    cekteam();
  }, []);

  return (
    <div>
      {teamrank != false && ubahteam == false ? (
        <>
          <center>
            <img
              src={teamrank.logo_team}
              className="img-fluid "
              alt=""
              style={{
                height: "150px",
                width: "150px",
                //   borderRadius: "100%",
                //   borderStyle: "solid",
              }}
            ></img>
            <br />
            <div className="mt-2">
              <small className="fw-bold mt-3">{teamrank.nama_team}</small>
              {cekbookingteam == null || cekbookingteam == "" ? (
                <>
                  <br />
                  <small
                    className="text-primary"
                    onClick={() => KlikUbahTeam()}
                    style={{ cursor: "pointer" }}
                  >
                    Ubah team anda ?
                  </small>
                </>
              ) : (
                <>
                  <br />
                  <small
                    className="text-primary"
                    onClick={() => setUbahteam(true)}
                    style={{ cursor: "pointer" }}
                  >
                    Ubah logo team anda ?
                  </small>
                </>
              )}
            </div>
          </center>
        </>
      ) : (
        <>
          {" "}
          <Form.Group className="mb-3" controlId="formBasicupload">
            <label for="images" class="drop-container" id="dropcontainer">
              <span class="drop-title">
                {nameImg == "" ? (
                  "Upload logo"
                ) : (
                  <>{load == true && loadingupload2 != true ? <> Loading ....</> : ""}</>
                )}

                {loadingupload2 == true ? <>Sukses!</> : ''}
              </span>

              <input
                type="file"
                id="images"
                className="form-control"
                accept="image/*"
                onChange={(e) => handleChangeImg(e)}
                required
              />
            </label>
            {cekbookingteam == null || cekbookingteam == "" ? (
              <>
                {" "}
                <div className="row">
                  <div className="col-sm-8 col-9">
                    {" "}
                    <input
                      type="text"
                      value={namateam}
                      className="form-control form-control-sm mt-3"
                      placeholder="Masukan nama team"
                      onChange={(e) => setNamateam(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-4 col-3">
                    {" "}
                    <button
                      className="btn btn-primary btn-sm mt-3"
                      disabled={namateam == "" || nameImg == "" ? true : false}
                      onClick={() => handleDatateam()}
                    >
                      {ubahteam == true ? "Ubah" : "Add"}
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <>
                {" "}
                <button
                  className="btn btn-primary w-100 btn-sm mt-3 rounded-pill"
                  disabled={nameImg == "" ? true : false}
                  onClick={() => handleDatateam()}
                >
                  {ubahteam == true ? "Ubah" : "Add"}
                </button>
              </>
            )}

            <ToastContainer />
          </Form.Group>
        </>
      )}
    </div>
  );
}
